import React, { useEffect, useState, useRef, useCallback } from "react";
import introVideo from "../../assets/StocaiOnboardingVideo.webm";
import { TiMediaPlayReverse } from "react-icons/ti";
import { IoCaretForward } from "react-icons/io5";
import { IoMdPlayCircle } from "react-icons/io";
import { IoPauseCircleSharp } from "react-icons/io5";
import { GoUnmute } from "react-icons/go";
import { BiSolidVolumeMute } from "react-icons/bi";

const Onboarding_main = ({ onSelectCoach, userId }) => {
  const videoPlayCountKey = `videoPlayCount_${userId}`;
  const hideVideoKey = `hideVideo_${userId}`;

  const [playCount, setPlayCount] = useState(() => {
    return parseInt(localStorage.getItem(videoPlayCountKey)) || 0;
  });

  // const [showVideo, setShowVideo] = useState(() => {
  //   return localStorage.getItem(hideVideoKey) !== "true" && playCount < 2;
  // });

  const [showVideo] = useState(() => {
    return localStorage.getItem(hideVideoKey) !== "true" && playCount < 2;
  });

  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef(null);

  const handleVideoEnd = () => {
    const updatedCount = playCount + 1;
    localStorage.setItem(videoPlayCountKey, updatedCount);
    setPlayCount(updatedCount);

    if (dontShowAgain) {
      localStorage.setItem(hideVideoKey, "true");
    }

    handleStartSession();
  };

  const handleStartSession = useCallback(() => {
    const coachData = { coachName: "Eira", selectedTime: 21 };
    onSelectCoach(coachData);
  }, [onSelectCoach]);

  useEffect(() => {
    if (videoRef.current && showVideo) {
      videoRef.current.play();
    } else {
      handleStartSession();
    }
  }, [showVideo, handleStartSession]);

  const togglePlayPause = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
    setIsMuted(video.muted);
  };

  const skipTime = (seconds) => {
    const video = videoRef.current;
    video.currentTime += seconds;
  };

  if (!showVideo) {
    return null;
  }

  return (
    <div className="fixed inset-0 min-h-screen flex justify-center font-gotham items-center bg-white z-50">
      <div className="flex flex-col items-center gap-4">
        <video
          ref={videoRef}
          className="w-[80vw] h-[45vw] max-w-[1280px] max-h-[720px] object-contain rounded-lg shadow-lg"
          src={introVideo}
          onEnded={handleVideoEnd}
          autoPlay
        />

        {/* Video Controls for Medium and Large Screens */}
        <div className="hidden md:flex gap-16 items-center justify-center bg-white w-full md:max-w-2xl lg:max-w-3xl p-3 rounded-xl shadow-lg border border-[#54B0AF]">
          <button
            onClick={() => skipTime(-10)}
            className="flex items-center gap-1 px-6 py-3 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition"
          >
            <span className="text-xl">
              <TiMediaPlayReverse className="font-gotham" />
            </span>
            <span className="text-md font-medium font-gotham">10s</span>
          </button>

          <button
            onClick={togglePlayPause}
            className="flex items-center gap-2 px-6 py-3 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition"
          >
            <span className="text-lg">
              {isPlaying ? (
                <IoPauseCircleSharp size={20} className="font-gotham" />
              ) : (
                <IoMdPlayCircle size={20} className="font-gotham" />
              )}
            </span>
            <span className="text-md font-medium font-gotham">
              {isPlaying ? "Pause" : "Play"}
            </span>
          </button>

          <button
            onClick={() => skipTime(10)}
            className="flex items-center gap-1 px-6 py-3 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition"
          >
            <span className="text-xl ">
              <IoCaretForward className="font-gotham" />
            </span>
            <span className="text-md font-medium font-gotham">10s</span>
          </button>

          <button
            onClick={toggleMute}
            className="flex items-center gap-2 px-6 py-3 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition"
          >
            <span className="text-xl">
              {isMuted ? (
                <BiSolidVolumeMute className="font-gotham" />
              ) : (
                <GoUnmute className="font-gotham" />
              )}
            </span>
            <span className="text-md font-medium font-gotham">
              {isMuted ? "Unmute" : "Mute"}
            </span>
          </button>
        </div>

        {/* Video Controls for Small Screens */}
        <div className="flex md:hidden gap-4 sm:gap-6 items-center justify-center bg-white p-2 sm:p-3 rounded-xl shadow-lg border border-[#54B0AF] overflow-x-auto w-full max-w-full">
          <button
            onClick={() => skipTime(-10)}
            className="flex items-center gap-1 px-2 py-1.5 sm:px-3 sm:py-2 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition whitespace-nowrap flex-shrink-0 justify-center"
          >
            <span className="text-sm sm:text-base mb-0.5">
              <TiMediaPlayReverse className="font-gotham" />
            </span>
            <span className="text-[10px] sm:text-sm font-medium font-gotham">
              10s
            </span>
          </button>

          <button
            onClick={togglePlayPause}
            className="flex items-center gap-1 sm:gap-2 px-3 py-1.5 sm:px-4 sm:py-2 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition whitespace-nowrap flex-shrink-0 justify-center"
          >
            <span className="text-sm sm:text-base mb-0.5">
              {isPlaying ? (
                <IoPauseCircleSharp
                  size={16}
                  className="sm:w-5 sm:h-5 font-gotham"
                />
              ) : (
                <IoMdPlayCircle
                  size={16}
                  className="sm:w-5 sm:h-5 font-gotham"
                />
              )}
            </span>
            <span className="text-[10px] sm:text-sm font-medium font-gotham">
              {isPlaying ? "Pause" : "Play"}
            </span>
          </button>

          <button
            onClick={() => skipTime(10)}
            className="flex items-center gap-1 px-2 py-1.5 sm:px-3 sm:py-2 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition whitespace-nowrap flex-shrink-0 justify-center"
          >
            <span className="text-sm sm:text-base mb-0.5">
              <IoCaretForward className="font-gotham" />
            </span>
            <span className="text-[10px] sm:text-sm font-medium font-gotham">
              10s
            </span>
          </button>

          <button
            onClick={toggleMute}
            className="flex items-center gap-1 sm:gap-2 px-2 py-1.5 sm:px-3 sm:py-2 bg-[#54B0AF] text-white rounded-full shadow hover:bg-teal-600 transition whitespace-nowrap flex-shrink-0 justify-center"
          >
            <span className="text-sm sm:text-base mb-0.5">
              {isMuted ? (
                <BiSolidVolumeMute className="font-gotham" />
              ) : (
                <GoUnmute className="font-gotham" />
              )}
            </span>
            <span className="text-[10px] sm:text-sm font-medium font-gotham">
              {isMuted ? "Unmute" : "Mute"}
            </span>
          </button>
        </div>

        {/* Don't Show Again Checkbox */}
        {/* <label className="text-black flex items-center gap-2">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          />
          Don't show this again
        </label> */}

        <label className="text-black flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
            className="peer hidden"
            id="customCheck"
          />
          <div className="w-5 h-5 rounded border-2 border-[#54B0AF] flex items-center justify-center peer-checked:bg-[#54B0AF]">
            {dontShowAgain && (
              <svg
                className="w-3 md:w-5 md:h-5 h-3 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
          <span className="text-[#323232] font-gotham font-medium text-sm md:text-base lg:text-xl">
            Don't show this again
          </span>
        </label>
      </div>
    </div>
  );
};

export default Onboarding_main;

// import React, { useEffect, useState, useRef } from "react";
// import introVideo from "../../assets/StocaiOnboardingVideo.webm";

// const Onboarding_main = ({ onSelectCoach, userId }) => {
//   // Keys based on user ID
//   const videoPlayCountKey = `videoPlayCount_${userId}`;
//   const hideVideoKey = `hideVideo_${userId}`;

//   // Read video play count from localStorage
//   const [playCount, setPlayCount] = useState(() => {
//     return parseInt(localStorage.getItem(videoPlayCountKey)) || 0;
//   });

//   // Determine if video should be shown
//   const [showVideo, setShowVideo] = useState(() => {
//     return localStorage.getItem(hideVideoKey) !== "true" && playCount < 2;
//   });

//   const [dontShowAgain, setDontShowAgain] = useState(false);
//   const videoRef = useRef(null);

//   // Handle when video ends
//   const handleVideoEnd = () => {
//     const updatedCount = playCount + 1;
//     localStorage.setItem(videoPlayCountKey, updatedCount);
//     setPlayCount(updatedCount);

//     if (dontShowAgain) {
//       localStorage.setItem(hideVideoKey, "true");
//     }

//     handleStartSession();
//   };

//   // Start coaching session after video
//   const handleStartSession = () => {
//     const coachData = { coachName: "Eira", selectedTime: 21 };
//     onSelectCoach(coachData);
//   };

//   // Auto play video when shown
//   useEffect(() => {
//     if (videoRef.current && showVideo) {
//       videoRef.current.play();
//     } else {
//       handleStartSession();
//     }
//   }, [showVideo]);

//   // If video shouldn't be shown, render nothing
//   if (!showVideo) {
//     return null;
//   }

//   return (
//     <div className="fixed inset-0 min-h-screen flex justify-center items-center bg-white z-50">
//       <div className="flex flex-col items-center gap-4">
//         <video
//           ref={videoRef}
//           className="w-[80vw] h-[45vw] max-w-[1280px] max-h-[720px] object-contain rounded-lg shadow-lg"
//           src={introVideo}
//           onEnded={handleVideoEnd}
//           autoPlay
//           // muted
//         />
//         <label className="text-black flex items-center gap-2">
//           <input
//             type="checkbox"
//             checked={dontShowAgain}
//             onChange={(e) => setDontShowAgain(e.target.checked)}
//           />
//           Don’t show this again
//         </label>
//       </div>
//     </div>
//   );
// };

// export default Onboarding_main;

// import React, { useState, useEffect } from "react";
// import Onboarding_one from "./components/Onboarding_one";
// import Onboarding_two from "./components/Onboarding_two";
// import Onboarding_three from "./components/Onboarding_three";
// import Onboarding_four from "./components/Onboarding_four";
// import Onboarding_five from "./components/Onboarding_five";
// import Onboarding_six from "./components/Onboarding_six";

// const Onboarding_main = ({ onSelectCoach }) => {
//   const [step, setStep] = useState(1);

//   const nextStep = () => {
//     setStep((prev) => (prev < 6 ? prev + 1 : prev));
//   };

//   const skipAll = () => {
//     setStep(6);
//   };

//   useEffect(() => {
//     if (step < 6) {
//       const timer = setTimeout(nextStep, 30000);
//       return () => clearTimeout(timer);
//     }
//   }, [step]);

//   const StepComponent = () => {
//     switch (step) {
//       case 1:
//         return <Onboarding_one onNext={nextStep} />;
//       case 2:
//         return <Onboarding_two onNext={nextStep} />;
//       case 3:
//         return <Onboarding_three onNext={nextStep} />;
//       case 4:
//         return <Onboarding_four onNext={nextStep} />;
//       case 5:
//         return <Onboarding_five onNext={nextStep} />;
//       case 6:
//         return <Onboarding_six onSelectCoach={onSelectCoach} />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="fixed inset-0 min-h-screen h-auto flex justify-center items-center bg-white backdrop-blur-xl z-50">
//       <div
//         key={step}
//         className="relative bg-white container h-auto mx-auto rounded-lg flex flex-col items-center justify-center transition-all duration-700 ease-in-out opacity-0 animate-fade-in"
//       >
//         {step < 6 && (
//           <div className="hidden md:block absolute right-2 top-20 md:top-32 md:right-10 lg:top-12 lg:right-2 z-50">
//             <button
//               onClick={skipAll}
//               className="text-lg font-semibold text-gray-800 bg-transparent bg-opacity-20 border border-gray-300 py-1 px-6 rounded-full hover:text-[#54B0AF] hover:border-[#54B0AF] transition-all backdrop-blur-sm"
//             >
//               Skip Onboarding
//             </button>
//           </div>
//         )}

//         {/* Mobile: show only on step 1 */}
//         {step === 1 && (
//           <div className="block md:hidden absolute right-2 top-20 z-50">
//             <button
//               onClick={skipAll}
//               className="text-base font-medium text-gray-700 bg-white bg-opacity-80 border border-gray-300 py-1 px-4 rounded-full hover:text-[#54B0AF] hover:border-[#54B0AF] transition-all backdrop-blur-sm"
//             >
//               Skip Onboarding
//             </button>
//           </div>
//         )}
//         <div className="w-full min-h-screen flex justify-center items-center">
//           <StepComponent />
//         </div>
//         <div className="fixed bottom-10 left-1/2 transform -translate-x-1/2 flex justify-center items-center space-x-2 z-50">
//           {[1, 2, 3, 4, 5, 6].map((page) => (
//             <span
//               key={page}
//               className={`h-3 w-3 rounded-full transition-all duration-300 ${
//                 step === page ? "bg-[#54B0AF]" : "bg-gray-300"
//               }`}
//             />
//           ))}

//           {step < 6 && (
//             <div className="absolute bottom-12 right-8 flex flex-col items-end z-50 md:hidden">
//               {/* Water Droplet */}
//               <div className="relative h-12 w-12 flex items-center justify-center">
//                 {/* Ripple Circles */}
//                 <div className="ripple absolute h-8 w-8 rounded-full border-2 border-[#54B0AF] opacity-70" />
//                 <div className="ripple absolute h-8 w-8 rounded-full border-2 border-[#54B0AF] opacity-70 animation-delay-300" />
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Onboarding_main;
